export class Cache {
    constructor() {
        this.cacheMap = new Map();
    }
    async addOrGetExisting(key, getNewItem) {
        let item = this.cacheMap.get(key);
        if (item === undefined) {
            item = await getNewItem();
            this.cacheMap.set(key, item);
        }
        return item;
    }
}
